// extracted by mini-css-extract-plugin
export default {"fs":"bcd7285a83 _1cb3ca65cd"};